import React, { useState, useEffect, useId } from 'react';
import { Form } from 'react-bootstrap';

const API_BASE = 'https://makeupmatch.onrender.com';

export function ProductSelectorWrapper({ onSelection }) {
  const instanceId = useId();

  const [brandValue, setBrandValue] = useState('');
  const [brandId, setBrandId] = useState(null);
  const [brandOptions, setBrandOptions] = useState([]);
  const [productValue, setProductValue] = useState('');
  const [productId, setProductId] = useState(null);
  const [productOptions, setProductOptions] = useState([]);
  const [shadeValue, setShadeValue] = useState('');
  const [shadeOptions, setShadeOptions] = useState([]);

  useEffect(() => {
    fetch(`${API_BASE}/brands?query=`)
      .then(res => res.json())
      .then(setBrandOptions)
      .catch(() => setBrandOptions([]));
  }, []);

  useEffect(() => {
    if (brandId) {
      fetch(`${API_BASE}/products?brand_id=${brandId}&query=`)
        .then(res => res.json())
        .then(setProductOptions)
        .catch(() => setProductOptions([]));
    } else {
      setProductOptions([]);
    }
  }, [brandId]);
  
  useEffect(() => {
    if (productId) {
      fetch(`${API_BASE}/shades?product_id=${productId}&query=`)
        .then(res => res.json())
        .then(setShadeOptions)
        .catch(() => setShadeOptions([]));
    } else {
      setShadeOptions([]);
    }
  }, [productId]);

  function handleBrandBlur() {
    const match = brandOptions.find(b => b.brand_name === brandValue);
    if (match) {
      if (match.brand_id !== brandId) {
        setBrandId(match.brand_id);
        setProductValue('');
        setProductId(null);
        setShadeValue('');
        
      }
    } else {
      setBrandId(null);
      setProductValue('');
      setProductId(null);
      setShadeValue('');
     
    }
  }
  function handleProductBlur() {
    const match = productOptions.find(p => p.product_name === productValue);
    if (match) {
      if (match.product_id !== productId) {
        setProductId(match.product_id);
        setShadeValue('');
      
      }
    } else {
      setProductId(null);
      setShadeValue('');
      
    }
  }
  function handleShadeBlur() {
    const match = shadeOptions.find(s => s.shade_name === shadeValue);
    if (match) {
      
      if (onSelection) {
        onSelection({
          brand: brandValue,
          brandId,
          product: productValue,
          productId,
          shade: shadeValue,
          shadeHex: match.hex
        });
      }
    }
  }

  return (
    <>
      <Form.Group>
        <Form.Label>Brand</Form.Label>
        <Form.Control
          list={`brands-list-${instanceId}`}
          placeholder="Select brand"
          value={brandValue}
          onChange={e => setBrandValue(e.target.value)}
          onBlur={handleBrandBlur}
          autoComplete="off"
        />
        <datalist id={`brands-list-${instanceId}`}>
          {brandOptions.map(b => (
            <option key={b.brand_id} value={b.brand_name} />
          ))}
        </datalist>
      </Form.Group>
      <Form.Group>
        <Form.Label>Product</Form.Label>
        <Form.Control
          list={`products-list-${instanceId}`}
          placeholder={brandId ? "Select product" : "Select brand first"}
          value={productValue}
          onChange={e => setProductValue(e.target.value)}
          onBlur={handleProductBlur}
          disabled={!brandId}
          autoComplete="off"
        />
        <datalist id={`products-list-${instanceId}`}>
          {productOptions.map(p => (
            <option key={p.product_id} value={p.product_name} />
          ))}
        </datalist>
      </Form.Group>
      <Form.Group>
        <Form.Label>Shade</Form.Label>
        <Form.Control
          list={`shades-list-${instanceId}`}
          placeholder={productId ? "Select shade" : "Select product first"}
          value={shadeValue}
          onChange={e => setShadeValue(e.target.value)}
          onBlur={handleShadeBlur}
          disabled={!productId}
          autoComplete="off"
        />
        <datalist id={`shades-list-${instanceId}`}>
          {shadeOptions.map(s => (
            <option key={s.shade_id} value={s.shade_name} />
          ))}
        </datalist>
      </Form.Group>
    </>
  );
}
